<template>
  <div>
    <div class=" mainLoader" v-if="loading">
      <!-- <img src="../assets/images/load.gif" width="100px"> -->
    </div>
    <div class="realbody">
      <div class="top_summary">
        <div class="container">
          <div class="row">
            <div class="col-md-6" style="padding: 45px 0px;">
              <p class="top_summary_header mplus2p-m spacing4 noiseblack">{{$t('cp_title')}}</p>
              <p class="top_summary_comment mplus2p-r spacing1-2 noiseblack">{{$t('cp_desc')}}</p>
            </div>
            <div class="col-md-6" style="text-align: center;">
              <img src="../../assets/imgs/companyprofile.png" class="pman" />
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row" style="margin-top: 40px;">
          <div class="col-md-3">
            <app-company-sidebar :selectedItem="selectedItem"></app-company-sidebar>
          </div>
          <div class="col-md-9">
            <div class="page_title">
              <span class="page_title_comment mplus2p-m spacing1-2 noiseblack">{{$t('message_list')}}</span>
            </div>

            <div class="row companyview-topoptions">
              <!-- <div class="col-md-3">
                  <div class="selectdiv">
                  <select>
                      <option class="checklabel mplus2p-m spacing1-2 noiseblack" value="aaa">{{$t('el_select')}}</option>
                      <option class="checklabel mplus2p-m spacing1-2 noiseblack" value="bbb">aaa</option>
                      <option class="checklabel mplus2p-m spacing1-2 noiseblack" value="ccc">aaa</option>
                  </select>
                  </div>
              </div> -->
              <!-- <div class="col-md-9">
                  <div class="rtoptions">
                  <input class="styled-checkbox" id="option01" type="checkbox" value="value01">
                  <label class="checklabel mplus2p-m spacing1-2 noiseblack" for="option01">{{$t('chatActiomSelectAll')}}</label>
                  </div>
              </div> -->
            </div>
            <div v-if="lists.length < 1" class="row actionitem">
              <div class="col-md-12 alert alert-danger text-center mb-0">
                <strong>{{$t('err_group')}}</strong>
              </div>
            </div>

            <div v-else v-for="(list,index) of lists" :key="index">
              <div class="row actionitem" v-if="list.last_message != null">
                <div class="col-md-12 text-right">
                  <!-- {{JSON.stringify(list)}} -->
                  <span class="chatdate mplus2p-r black spacing1-2">{{list.message_time ? list.message_time : ""}}</span>
                  <span v-if="!list.last_message_read" class="chatdate mplus2p-r black spacing1-2">
                    <i class="fa fa-circle red chatmanstatus" aria-hidden="true"></i></span>
                </div>
                <!-- <div class="col-md-2">
                    <div class="irighter">
                    <div class="i_rtoptions">
                        <input class="styled-checkbox" id="option02" type="checkbox" value="value02">
                        <label class="checklabel mplus2p-m spacing1-2 noiseblack" for="option02"></label>
                    </div>
                    <img class="big_tip img-responsive rounded" :src="list.receiver_profile" />
                    </div>
                </div> -->
                <div class="col-md-12 bodier">
                  <!-- <router-link :to="{ name: 'companyEngineerDetail', params: {uid: list.user_id} }" target="_blank"> -->
                  <p v-if="role == 'company_user'" class=" mplsu2p-m spacing1-2 black">
                    {{list.receiver_name}}
                  </p>
                  <!-- </router-link> -->
                  <p class="aicontent mplus2p-m spacing1-2 green">{{list.last_message}}
                  </p>
                  <a href="javascript:void(0)" @click="sandMsg(list.user_id)">
                    <button class="btn bluebtn clickcbtn" style="float: right;">
                      <i class="fa fa-envelope margin-r-5"></i>
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Hashids from "hashids";
import axios from "axios";
import companySidebar from "./company_sidebar";
import {EventBus} from "../../main.js";

export default {
  data() {
    return {
      selectedItem: 31,

      loading: false,

      lists: [],
      role: ""
    };
  },
  components: {
    appCompanySidebar: companySidebar
  },
  mounted() {
    this.role = localStorage.getItem("role");
    this.chatActionList();
  },
  methods: {
    sandMsg(engineerId) {
      var hashids = new Hashids(
        "this is my salt",
        8,
        "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890"
      );
      this.$router.push("/global/chatroom/" + hashids.encode(engineerId));
      EventBus.$emit("notificationCount", {id :engineerId , admin_mail: false} );
    },
    chatActionList() {
      this.loading = true;
      axios
        .get("/chataction-list?&token=" + localStorage.getItem("token"), {
          headers: { "X-localization": localStorage.getItem("lan") }
        })
        .then(res => {
          if (!res.data.result) {
            if (res.data[0]) {
              this.$toaster.error(res.data[0]);
              this.$store.dispatch("logout");
            }
            this.loading = false;
          } else {
            //this.lists = [];
            for (var i = 0; i < res.data.conversation.length; i++) {
              if (res.data.conversation[i].last_message != null)
                res.data.conversation[i].last_message = res.data.conversation[
                  i
                ].last_message.replace(/\<br \/\>/g, " ");
              // .replace(/(?:\r\n|\r|\n|↵)/g, "");
              this.lists.push(res.data.conversation[i]);
            }
            this.$forceUpdate();
            this.loading = false;
          }
        })
        .catch(error => console.log(error));
    }
  }
};
</script>

<style scoped>
.pman {
  width: auto;
  margin-top: 20px;
}

.companyview-topoptions {
  padding: 10px 15px;
  margin-top: 10px;
}

.companyview-topoptions .col-md-3 {
  padding: 0;
}

.companyview-topoptions .col-md-9 {
  padding: 0;
}

.selectdiv:after {
  content: "\f107";
  color: #6474847d;
  top: 3px;
}

.selectdiv select {
  height: 44px;
}

.rtoptions {
  margin-top: 14px;
  float: left;
  margin-left: 40px;
}

.chatdate {
  font-size: 0.75rem;
}

.chatmanstatus {
  font-size: 0.625rem;
  margin-left: 4px;
}

.big_tip {
  width: 80px;
  width: 80px;
}

.actionitem {
  border-radius: 4px;
  box-shadow: 0 1px 4px 0 rgba(60, 80, 100, 0.12);
  background-color: #ffffff;
  border: solid 1px #e8eaee;
  padding: 10px 5px;
  margin: 0;
  margin-bottom: 18px;
}

.i_rtoptions {
  margin-top: 25px;
  float: left;
}

.aiitem {
  font-size: 0.75rem;
  font-weight: 500;
}

.aicontent {
  font-size: 0.825rem;
  font-weight: 500;
  margin-bottom: 10px;
  margin-top: 0px;
  height: auto;
  white-space: pre-wrap;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-all;
}

.irighter {
  width: 110px;
}
.bodier2:hover {
  cursor: pointer;
}
@media screen and (max-width: 992px) {
  .bodier {
    padding: 0px 50px;
  }
}

@media screen and (max-width: 768px) {
  .page_title {
    margin-top: 40px;
  }

  .bodier {
    margin-top: 20px;
    padding: 0px 15px;
  }

  .rtoptions {
    margin-left: 5px;
  }
}
</style>
